import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {
    ModalDialog,
    ModalLauncher,
    ModalPanel,
} from "@khanacademy/wonder-blocks-modal";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {staticUrl} from "@khan/urls";

import {ReferralContent} from "./khanmigo-for-teachers-referral-banner.tsx";

export const KhanmigoForTeachersReferralInProductModal = ({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) => {
    return (
        <ModalLauncher
            modal={() => (
                <ModalDialog
                    aria-labelledby="referral-modal-header"
                    style={{width: "auto", height: "auto"}}
                >
                    <ModalPanel
                        style={styles.modalContainer}
                        content={
                            <View style={styles.modalContent}>
                                <img
                                    src={staticUrl(
                                        "/images/khanmigo-for-teachers-referrals/khanmigo-collage-2x-v2.png",
                                    )}
                                    alt=""
                                    style={{
                                        maxWidth: "190px",
                                        margin: "0 auto",
                                    }}
                                />
                                <Strut size={spacing.large_24} />
                                <HeadingSmall
                                    style={styles.modalHeading}
                                    id="referral-modal-header"
                                >
                                    {t`You and Khanmigo are on a roll!`}
                                </HeadingSmall>
                                <Strut size={spacing.large_24} />
                                <Body style={styles.modalBody}>
                                    {t`Nice work on that lesson plan! Tell your teacher friends to try Khanmigo and be entered to win prizes when they sign up.`}
                                </Body>
                                <Strut size={spacing.large_24} />
                                <ReferralContent
                                    buttonStyles={styles.copyButton}
                                />
                            </View>
                        }
                    />
                </ModalDialog>
            )}
            opened={isOpen}
            onClose={onClose}
        />
    );
};

const styles = StyleSheet.create({
    modalContainer: {
        maxWidth: "566px",
        maxHeight: "389px",
        textAlign: "center",
        borderRadius: "4px",
    },
    modalContent: {
        margin: "0 auto",
    },
    modalHeading: {
        fontSize: "24px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "28px",
    },
    modalBody: {
        width: "500px",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
    },
    copyButton: {
        width: "217px",
        height: "40px",
        margin: "0 auto",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "20px",
    },
});
